import * as THREE from 'three';

export class ChaseCamera {
  private readonly idealOffset = new THREE.Vector3(0, 4.5, -10);
  private readonly idealLookAt = new THREE.Vector3(0, 1.2, 6);
  private readonly tmpOffset = new THREE.Vector3();
  private readonly tmpLook = new THREE.Vector3();

  constructor(private readonly camera: THREE.PerspectiveCamera) {}

  update(targetPos: THREE.Vector3, targetQuat: THREE.Quaternion, dt: number) {
    const smoothing = 1 - Math.pow(0.001, dt);

    this.tmpOffset.copy(this.idealOffset).applyQuaternion(targetQuat).add(targetPos);
    this.camera.position.lerp(this.tmpOffset, smoothing);

    this.tmpLook.copy(this.idealLookAt).applyQuaternion(targetQuat).add(targetPos);
    this.camera.lookAt(this.tmpLook);
  }
}
